"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfStoredDocumentDto = instanceOfStoredDocumentDto;
exports.StoredDocumentDtoFromJSON = StoredDocumentDtoFromJSON;
exports.StoredDocumentDtoFromJSONTyped = StoredDocumentDtoFromJSONTyped;
exports.StoredDocumentDtoToJSON = StoredDocumentDtoToJSON;
exports.StoredDocumentDtoToJSONTyped = StoredDocumentDtoToJSONTyped;
const StoredDocumentType_1 = require("./StoredDocumentType");
/**
 * Check if a given object implements the StoredDocumentDto interface.
 */
function instanceOfStoredDocumentDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('documentType' in value) || value['documentType'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
function StoredDocumentDtoFromJSON(json) {
    return StoredDocumentDtoFromJSONTyped(json, false);
}
function StoredDocumentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'documentType': (0, StoredDocumentType_1.StoredDocumentTypeFromJSON)(json['documentType']),
        'fileName': json['fileName'],
        'fileSize': json['fileSize'],
        'mimeType': json['mimeType'],
        'url': json['url'],
    };
}
function StoredDocumentDtoToJSON(json) {
    return StoredDocumentDtoToJSONTyped(json, false);
}
function StoredDocumentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'documentType': (0, StoredDocumentType_1.StoredDocumentTypeToJSON)(value['documentType']),
        'fileName': value['fileName'],
        'fileSize': value['fileSize'],
        'mimeType': value['mimeType'],
        'url': value['url'],
    };
}
//# sourceMappingURL=StoredDocumentDto.js.map